export const categories = [
  { slug: 'mingxing-bagua', name: '明星八卦', icon: 'ri-star-line', color: 'primary' },
  { slug: 'shipin-heiliao', name: '视频黑料', icon: 'ri-video-line', color: 'accent' },
  { slug: 'tuwen-shichui', name: '图文实锤', icon: 'ri-image-line', color: 'secondary' },
  { slug: 'wanghong-fancheshijian', name: '网红翻车', icon: 'ri-alert-line', color: 'primary' },
  { slug: 'zhibo-chigua', name: '直播吃瓜', icon: 'ri-live-line', color: 'accent' },
  { slug: 'yule-shendu', name: '娱乐深度', icon: 'ri-search-eye-line', color: 'secondary' },
  { slug: 'neiyu-bagua', name: '内娱八卦', icon: 'ri-chat-smile-2-line', color: 'primary' },
  { slug: 'jingdian-tafang', name: '经典塌房', icon: 'ri-emotion-sad-line', color: 'accent' },
];

export const articles = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店同住三天两夜全程实拍',
    excerpt: '据知情人爆料，该男星近期作品热度正盛，却在此关键节点被拍到与圈外女性深夜同行。全程高清实拍画面已流出，细节令人咋舌。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20paparazzi%20photography%20of%20a%20luxury%20hotel%20entrance%20at%20night%20with%20a%20celebrity%20silhouette%20walking%20through%20revolving%20doors%20neon%20city%20lights%20reflecting%20on%20wet%20pavement%20cinematic%20composition%20with%20deep%20shadows%20and%20mysterious%20atmosphere%20rich%20black%20and%20crimson%20tones%20editorial%20style&width=800&height=1000&seq=article-hero-01&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20moody%20paparazzi%20photography%20of%20a%20luxury%20hotel%20entrance%20at%20night%20with%20a%20celebrity%20silhouette%20walking%20through%20revolving%20doors%20neon%20city%20lights%20reflecting%20on%20wet%20pavement%20cinematic%20composition%20with%20deep%20shadows%20and%20mysterious%20atmosphere%20rich%20black%20and%20crimson%20tones%20editorial%20style&width=800&height=1200&seq=article-thumb-01&orientation=portrait',
    date: '2026-07-06',
    views: 1285000,
    comments: 38420,
    tags: ['顶流', '偷拍', '恋情'],
    featured: true,
    videoUrl: '',
    content: '',
  },
  {
    id: 2,
    title: '选秀冠军人设崩塌？前经纪人曝光录音：所有的温柔都是演出来的',
    excerpt: '一段长达12分钟的录音今晨在网络疯传，前经纪人实名爆料选秀冠军私下真实面目。录音中清晰可辨多个争议言论，粉丝集体破防。',
    category: '视频黑料',
    categorySlug: 'shipin-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20studio%20scene%20with%20a%20shattered%20mirror%20on%20the%20floor%20reflecting%20a%20microphone%20and%20recording%20device%20warm%20amber%20light%20piercing%20through%20darkness%20broken%20glass%20pieces%20scattered%20cinematic%20noir%20style%20with%20deep%20blacks%20and%20golden%20highlights%20intense%20mysterious%20mood&width=800&height=1000&seq=article-hero-02&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20studio%20scene%20with%20a%20shattered%20mirror%20on%20the%20floor%20reflecting%20a%20microphone%20and%20recording%20device%20warm%20amber%20light%20piercing%20through%20darkness%20broken%20glass%20pieces%20scattered%20cinematic%20noir%20style%20with%20deep%20blacks%20and%20golden%20highlights%20intense%20mysterious%20mood&width=800&height=1200&seq=article-thumb-02&orientation=portrait',
    date: '2026-07-05',
    views: 2340000,
    comments: 56780,
    tags: ['选秀', '录音', '人设崩塌'],
    featured: true,
    videoUrl: '',
    content: '',
  },
  {
    id: 3,
    title: '千万粉丝网红直播间翻车，口误说出品牌方真实成本价',
    excerpt: '某带货一姐在直播中意外透露某大牌护肤品真实成本不到售价的5%，品牌方当场切断合作。该片段已被网友录屏并广泛传播。',
    category: '直播吃瓜',
    categorySlug: 'zhibo-chigua',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20livestream%20studio%20scene%20with%20bright%20ring%20lights%20a%20shocked%20expression%20frozen%20on%20screen%20multiple%20phone%20screens%20displaying%20reactions%20scattered%20products%20on%20table%20dark%20moody%20atmosphere%20with%20neon%20pink%20and%20electric%20blue%20accents%20cinematic%20wide%20shot&width=800&height=1000&seq=article-hero-03&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dramatic%20livestream%20studio%20scene%20with%20bright%20ring%20lights%20a%20shocked%20expression%20frozen%20on%20screen%20multiple%20phone%20screens%20displaying%20reactions%20scattered%20products%20on%20table%20dark%20moody%20atmosphere%20with%20neon%20pink%20and%20electric%20blue%20accents%20cinematic%20wide%20shot&width=800&height=1200&seq=article-thumb-03&orientation=portrait',
    date: '2026-07-04',
    views: 4560000,
    comments: 89120,
    tags: ['直播翻车', '带货', '品牌方'],
    featured: true,
    videoUrl: '',
    content: '',
  },
  {
    id: 4,
    title: '某知名导演被多位女演员联名举报，圈内大佬纷纷站队',
    excerpt: '三位女演员联合发布声明，指控某知名导演在拍摄期间存在不当行为。此事迅速引发行业震动，多位业内人士表态支持受害者。',
    category: '图文实锤',
    categorySlug: 'tuwen-shichui',
    image: 'https://readdy.ai/api/search-image?query=Dark%20editorial%20photography%20of%20three%20silhouetted%20figures%20standing%20together%20with%20determination%20court%20documents%20scattered%20on%20a%20wooden%20table%20dramatic%20side%20lighting%20creating%20long%20shadows%20cinematic%20composition%20with%20deep%20charcoal%20tones%20and%20subtle%20crimson%20accents%20powerful%20atmosphere&width=800&height=1000&seq=article-hero-04&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20editorial%20photography%20of%20three%20silhouetted%20figures%20standing%20together%20with%20determination%20court%20documents%20scattered%20on%20a%20wooden%20table%20dramatic%20side%20lighting%20creating%20long%20shadows%20cinematic%20composition%20with%20deep%20charcoal%20tones%20and%20subtle%20crimson%20accents%20powerful%20atmosphere&width=800&height=1200&seq=article-thumb-04&orientation=portrait',
    date: '2026-07-03',
    views: 5670000,
    comments: 102340,
    tags: ['导演', '举报', '行业震动'],
    featured: false,
    videoUrl: '',
    content: '',
  },
  {
    id: 5,
    title: '热门综艺录制现场冲突画面流出，两位常驻嘉宾大打出手',
    excerpt: '据现场工作人员透露，冲突起因是游戏环节中的一次意外碰撞。监控画面显示两人从口角升级为肢体冲突，节目组已紧急叫停录制。',
    category: '视频黑料',
    categorySlug: 'shipin-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Blurred%20surveillance%20camera%20style%20image%20showing%20two%20figures%20in%20confrontation%20on%20a%20TV%20studio%20set%20bright%20stage%20lights%20creating%20harsh%20shadows%20equipment%20scattered%20around%20dramatic%20tension%20captured%20in%20motion%20dark%20cinematic%20color%20grading%20with%20high%20contrast%20black%20and%20deep%20red&width=800&height=1000&seq=article-hero-05&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Blurred%20surveillance%20camera%20style%20image%20showing%20two%20figures%20in%20confrontation%20on%20a%20TV%20studio%20set%20bright%20stage%20lights%20creating%20harsh%20shadows%20equipment%20scattered%20around%20dramatic%20tension%20captured%20in%20motion%20dark%20cinematic%20color%20grading%20with%20high%20contrast%20black%20and%20deep%20red&width=800&height=1200&seq=article-thumb-05&orientation=portrait',
    date: '2026-07-02',
    views: 3450000,
    comments: 67890,
    tags: ['综艺', '冲突', '现场'],
    featured: false,
    videoUrl: '',
    content: '',
  },
  {
    id: 6,
    title: '某影视公司CEO被曝婚内出轨多名女艺人，聊天记录全曝光',
    excerpt: '一组涉及某影视公司CEO的私密聊天记录今日被大规模泄露，内容涉及与多名签约女艺人的不正当关系。该CEO名下有三家上市公司，股价应声下跌。',
    category: '娱乐深度',
    categorySlug: 'yule-shendu',
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20at%20night%20with%20scattered%20documents%20on%20a%20glass%20desk%20blurred%20smartphone%20screens%20showing%20chat%20messages%20dramatic%20window%20light%20casting%20long%20shadows%20luxurious%20yet%20ominous%20atmosphere%20deep%20navy%20and%20charcoal%20tones%20cinematic%20noir%20aesthetic&width=800&height=1000&seq=article-hero-06&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20at%20night%20with%20scattered%20documents%20on%20a%20glass%20desk%20blurred%20smartphone%20screens%20showing%20chat%20messages%20dramatic%20window%20light%20casting%20long%20shadows%20luxurious%20yet%20ominous%20atmosphere%20deep%20navy%20and%20charcoal%20tones%20cinematic%20noir%20aesthetic&width=800&height=1200&seq=article-thumb-06&orientation=portrait',
    date: '2026-07-01',
    views: 7890000,
    comments: 145600,
    tags: ['出轨', '聊天记录', 'CEO'],
    featured: true,
    videoUrl: '',
    content: '',
  },
  {
    id: 7,
    title: '新晋小花被爆学历造假，母校教务处回应：查无此人',
    excerpt: '该女星在多个采访中声称毕业于某985高校表演系，然而记者实地探访发现，教务处系统中并无其学籍记录。其工作室尚未回应。',
    category: '内娱八卦',
    categorySlug: 'neiyu-bagua',
    image: 'https://readdy.ai/api/search-image?query=Moody%20university%20campus%20scene%20at%20dusk%20empty%20hallway%20with%20lockers%20a%20single%20graduation%20certificate%20lying%20on%20the%20floor%20under%20dramatic%20spotlight%20deep%20shadows%20academic%20atmosphere%20with%20mystery%20cinematic%20composition%20dark%20teal%20and%20warm%20amber%20tones&width=800&height=1000&seq=article-hero-07&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Moody%20university%20campus%20scene%20at%20dusk%20empty%20hallway%20with%20lockers%20a%20single%20graduation%20certificate%20lying%20on%20the%20floor%20under%20dramatic%20spotlight%20deep%20shadows%20academic%20atmosphere%20with%20mystery%20cinematic%20composition%20dark%20teal%20and%20warm%20amber%20tones&width=800&height=1200&seq=article-thumb-07&orientation=portrait',
    date: '2026-06-30',
    views: 1890000,
    comments: 45670,
    tags: ['学历造假', '小花', '调查'],
    featured: false,
    videoUrl: '',
    content: '',
  },
  {
    id: 8,
    title: '两年前塌房男星疑似复出，新剧低调开机引网友抵制',
    excerpt: '该男星因私生活问题两年前宣布退圈，近日被拍到在某影视基地参与新剧拍摄。消息传出后，相关话题迅速登上热搜，网友态度两极分化。',
    category: '经典塌房',
    categorySlug: 'jingdian-tafang',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20film%20set%20at%20golden%20hour%20a%20lone%20figure%20walking%20toward%20a%20camera%20crew%20silhouetted%20against%20warm%20sunset%20light%20equipment%20and%20cables%20creating%20geometric%20patterns%20tension%20between%20comeback%20and%20controversy%20dark%20moody%20undertones&width=800&height=1000&seq=article-hero-08&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20film%20set%20at%20golden%20hour%20a%20lone%20figure%20walking%20toward%20a%20camera%20crew%20silhouetted%20against%20warm%20sunset%20light%20equipment%20and%20cables%20creating%20geometric%20patterns%20tension%20between%20comeback%20and%20controversy%20dark%20moody%20undertones&width=800&height=1200&seq=article-thumb-08&orientation=portrait',
    date: '2026-06-29',
    views: 2340000,
    comments: 78900,
    tags: ['复出', '抵制', '新剧'],
    featured: false,
    videoUrl: '',
    content: '',
  },
  {
    id: 9,
    title: '某女团成员被站姐脱粉回踩，独家练习室霸凌画面首次公开',
    excerpt: '一位曾为该女团服务三年的站姐今日公开发布多条视频，指控某人气成员长期霸凌队友。视频中清晰记录了练习室内的不当行为。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dance%20practice%20room%20with%20mirrored%20walls%20reflecting%20tension%20between%20figures%20dramatic%20overhead%20lighting%20harsh%20shadows%20on%20the%20floor%20one%20figure%20isolated%20from%20the%20group%20cold%20atmospheric%20blue%20tones%20with%20warm%20accent%20light%20cinematic%20documentary%20style%20photography&width=800&height=1000&seq=article-hero-09&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20dance%20practice%20room%20with%20mirrored%20walls%20reflecting%20tension%20between%20figures%20dramatic%20overhead%20lighting%20harsh%20shadows%20on%20the%20floor%20one%20figure%20isolated%20from%20the%20group%20cold%20atmospheric%20blue%20tones%20with%20warm%20accent%20light%20cinematic%20documentary%20style%20photography&width=800&height=1200&seq=article-thumb-09&orientation=portrait',
    date: '2026-06-28',
    views: 4120000,
    comments: 98760,
    tags: ['女团', '霸凌', '脱粉'],
    featured: true,
    videoUrl: '',
    content: '',
  },
  {
    id: 10,
    title: '知名歌手演唱会假唱被技术博主实锤，音频分析对比放出',
    excerpt: '一位拥有百万粉丝的音频技术博主发布详细分析视频，通过频谱对比证明某知名歌手连续三场演唱会均存在假唱行为。',
    category: '视频黑料',
    categorySlug: 'shipin-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Dark%20studio%20with%20audio%20equipment%20waveform%20displays%20on%20multiple%20monitors%20showing%20comparison%20graphs%20dramatic%20technical%20atmosphere%20with%20blue%20screen%20glow%20illuminating%20a%20focused%20figure%20headphones%20and%20mixing%20console%20in%20foreground%20cinematic%20tech%20noir%20style&width=800&height=1000&seq=article-hero-10&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20studio%20with%20audio%20equipment%20waveform%20displays%20on%20multiple%20monitors%20showing%20comparison%20graphs%20dramatic%20technical%20atmosphere%20with%20blue%20screen%20glow%20illuminating%20a%20focused%20figure%20headphones%20and%20mixing%20console%20in%20foreground%20cinematic%20tech%20noir%20style&width=800&height=1200&seq=article-thumb-10&orientation=portrait',
    date: '2026-06-27',
    views: 3450000,
    comments: 67890,
    tags: ['假唱', '演唱会', '技术分析'],
    featured: false,
    videoUrl: '',
    content: '',
  },
  {
    id: 11,
    title: '某综艺导师被曝收选手好处费，转账记录与录音双料曝光',
    excerpt: '一份涉及某选秀节目导师的银行转账记录和电话录音今日被公开。录音中该导师明确表示可以"安排晋级名额"，金额高达七位数。',
    category: '娱乐深度',
    categorySlug: 'yule-shendu',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20a%20judging%20panel%20table%20with%20empty%20chairs%20harsh%20spotlight%20creating%20long%20shadows%20bank%20statement%20papers%20scattered%20mysterious%20envelope%20under%20dramatic%20lighting%20cinematic%20noir%20atmosphere%20deep%20blacks%20with%20selective%20golden%20highlights&width=800&height=1000&seq=article-hero-11&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20a%20judging%20panel%20table%20with%20empty%20chairs%20harsh%20spotlight%20creating%20long%20shadows%20bank%20statement%20papers%20scattered%20mysterious%20envelope%20under%20dramatic%20lighting%20cinematic%20noir%20atmosphere%20deep%20blacks%20with%20selective%20golden%20highlights&width=800&height=1200&seq=article-thumb-11&orientation=portrait',
    date: '2026-06-26',
    views: 5670000,
    comments: 123400,
    tags: ['综艺', '贿赂', '选秀'],
    featured: false,
    videoUrl: '',
    content: '',
  },
  {
    id: 12,
    title: '某品牌代言人私下吐槽产品被偷拍，品牌方紧急撤下所有物料',
    excerpt: '一段在某私人聚会上的偷拍视频显示，某知名品牌代言人向友人吐槽所代言产品质量问题。视频流出后品牌方连夜撤下全国门店海报。',
    category: '网红翻车',
    categorySlug: 'wanghong-fancheshijian',
    image: 'https://readdy.ai/api/search-image?query=Intimate%20dinner%20party%20scene%20with%20warm%20ambient%20lighting%20candid%20moment%20captured%20through%20a%20window%20silhouettes%20of%20people%20talking%20dramatic%20contrast%20between%20warm%20interior%20and%20cold%20exterior%20dark%20cinematic%20style%20with%20voyeuristic%20perspective%20moody%20atmosphere&width=800&height=1000&seq=article-hero-12&orientation=portrait',
    imageThumb: 'https://readdy.ai/api/search-image?query=Intimate%20dinner%20party%20scene%20with%20warm%20ambient%20lighting%20candid%20moment%20captured%20through%20a%20window%20silhouettes%20of%20people%20talking%20dramatic%20contrast%20between%20warm%20interior%20and%20cold%20exterior%20dark%20cinematic%20style%20with%20voyeuristic%20perspective%20moody%20atmosphere&width=800&height=1200&seq=article-thumb-12&orientation=portrait',
    date: '2026-06-25',
    views: 1230000,
    comments: 34560,
    tags: ['代言人', '翻车', '偷拍'],
    featured: false,
    videoUrl: '',
    content: '',
  },
];

export const featuredArticles = articles.filter(a => a.featured);

export const getArticlesByCategory = (slug: string) => {
  const cat = categories.find(c => c.slug === slug);
  if (!cat) return [];
  return articles.filter(a => a.categorySlug === slug);
};

export const getArticleById = (id: number) => {
  return articles.find(a => a.id === id);
};